module.exports = __webpack_public_path__ + "img/Categories_bg_002.3c9e3465.jpg";